/**
 * @module SalesFlow/evolved/view
 */

declare var $: JQueryStatic;

import Offer from 'view/view/shared/offer/offer';
import { FlowCtas } from 'view/ctas/shared/flow-ctas';
import { FlowCta } from 'view/ctas/shared/flow-cta';
import Injector from 'core/injector';

/**
 * Only one button in the pricebox module and in costoverview
 * Right: Link to basket with the recommanded subscription
 *
 * @export
 * @class ViewEvolvedInlifeCtasInlifeTariffSelection
 * @extends {FlowCtas}
 */
export class ViewEvolvedInlifeCtasInlifeTariffSelection extends FlowCtas {
    private _showRedXLNotification: boolean;
    private _checkboxStateStorageKey: string = 'checkedRedXLWarningHint';

    constructor (injector: Injector, showRedXLNotification: boolean) {
        super(injector);
        this._showRedXLNotification = showRedXLNotification;
    }

    protected getRightButton (): FlowCta {

        const buttonText = this.getInjector().getStrings().get('pricebox.confirm.basket');

        return new FlowCta(
            ['nfs-recommendation-confirm'],
            buttonText
        );
    }

    protected getRightCtaUrl (): string {

        const rightCtaUrl = '#proceedToBasket';

        return rightCtaUrl;

    }

    protected events (): void {

        super.events();

        this._element.on('click', this._right.getSelector(), (evt: JQueryEventObject) => {

            evt.preventDefault();

            this.createBasketAndProceed();

        });

        $(document).on('change', '#redXlWarningCheckbox', (e) => {
            const checkbox = <HTMLInputElement> e.currentTarget;

            this.getInjector().getStorage().setItem('checkedRedXLWarningHint', checkbox.checked + '');
            this.toggleButtonDisablement(checkbox.checked);
            this.getInjector().getStorage().setItem(this._checkboxStateStorageKey, checkbox.checked + '');
        });

        $(document).on('click', '.redxl-warning .close', () => {
            $('.redxl-warning').hide();
        });

    }

    private ShowRedXLTooltip (): void {
        $('.redxl-warning').show();
    }

    protected toggleButtonDisablement (enable: boolean) {
        if (enable) {
            $('.redxl-warning').hide();
            $('.redXL-disabled').parent().off('click', this.ShowRedXLTooltip);
            $('.nfs-recommendation-confirm').removeAttr('disabled').removeClass('redXL-disabled');
        } else {
            $('.nfs-recommendation-confirm').attr('disabled', 'disabled').addClass('redXL-disabled');
            $('.redXL-disabled').parent().on('click', this.ShowRedXLTooltip);
        }
    }

    public update (offer: Offer): void {

        if (undefined === offer) {
            return;
        }

        this._right.setHref(
            this.getRightCtaUrl()
        );

        this._right.setNotification(
            this.getInjector().getTemplates().render('inlife-redxl-tooltip', {}, 'partials')
        );

        this._element.html(
            this.getInjector().getTemplates().render('flow-ctas', [this._right], 'partials')
        );

        if (this._showRedXLNotification) {
            $('.redXlAnnotation-belt').show();
            const checkboxState = this.getInjector().getStorage().getItem(this._checkboxStateStorageKey);
            this.toggleButtonDisablement('true' === checkboxState);
        }
    }
}
